<!--
  -  Copyright (c) Qwoach LLC 2022. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 6/9/2022
  -->

<template>
	<div :class="isEmbedded ? '' : 'login-view-root'">

		<!--    <div class="body-div layout-centered bg-img" style="" :style="{backgroundImage: 'url(' + require('@/assets/img/bg/8.jpg') + ')'}">-->
		<div :class="isEmbedded ? '' : 'body-div layout-centered bg-img'">

			<!--    <div class="layout-centered bg-img" style="background-image:url('@/assets/img/bg/4.jpg')">-->


			<main :class="isEmbedded ? '' : 'main-content'">

				<div :class="embeddedClass" @mouseup="clearFormValidationInternal()">
					<div v-if="passwordResetSuccess">
						<h5 class="mb-5">Instructions were sent to {{ form.email }}</h5>
						<p class="mb-5">Please check your inbox for further instructions on how to reset your password</p>
						<el-button class="w-100" :loading="isProgressShowing" type="primary"
								   @click="backToLogin">Back to Login
						</el-button>
					</div>

					<div v-else>

						<h5 class="mb-5">Recover your password</h5>
						<p class="mb-5">An email will be sent to the email address bellow with further instructions on how to reset your password.</p>
						<qw-form :model="form"
								 :rules="rules"
								 ref="mainForm"
								 novalidate="novalidate"
								 @submit.prevent="submitForm()"
						>
							<FormTextRow
								v-if="isEmbedded"
								prop="email"
								:is-vertical="true"
								placeholder="Email Address"
								v-model="form.email"
							/>
							<FormTextRow
								v-else
								prop="email"
								v-model="form.email"
								class="form-group mb-4"
								placeholder="Email Address"/>

							<div class="pt-2">
								<qw-button class="w-100 py-3" :loading="isProgressShowing" type="primary" @click="submitForm()">
									Send Password Reset Email
								</qw-button>
							</div>
						</qw-form>
						<div v-if="errorMessage" class="text-danger pt-3">
							{{errorMessage}}
						</div>


						<div class="form-group flexbox py-3">
							<div class="layout-spacer"></div>

							<a class="text-muted small-2" href="#" @click.prevent="backToLogin">Back to login</a>
						</div>
					</div>

				</div>

			</main><!-- /.main-content -->


		</div>
	</div>
</template>


<script>

import * as emailValidator from "email-validator"



import BaseComponent from "@/core/components/BaseComponent.vue";
import FormTextRow from "@/core/components/Form/FormTextRow.vue";
import FormRow from "@/core/components/Form/Base/FormRow.vue";
import {emailFormValidatorFn, formTriggerEmail} from "@/utils/helpers.js";

export default {
	components: {FormRow, FormTextRow},
	extends: BaseComponent,
	name: "RestoreAccessView",

	props: {
		isEmbedded: Boolean,
		isLoginCoach: Boolean,
		email: String,
		onBack: Function
	},

	watch:{
		email:{
			immediate: true,
			handler(){
				if(this.email){
					this.form.email = this.email
				}
			}
		}
	},


	data() {
		return {
			passwordResetSuccess: false,
			form: {
				email: "",
			},
			rules: {

				email: emailFormValidatorFn()

			},

		}
	},

	computed: {

		embeddedClass(){
			return this.isEmbedded ? "qwoach-form" : "bg-white shadow-7 w-400 mw-100 p-5"
		},

		backToLoginLink() {
			return {
				name: this.isLoginCoach ? 'LoginCoach' : 'Login',
				params: this.$route.params,
				query: this.$route.query,
			}
		}
	},
	methods: {
		// onFormValidated() {
		// 	this.showProgressLoading()
		// 		.for(_ => this.restorePassword(this.form.email))
		// 		.then(user => {
		// 			this.toast("We've emailed you the instructions. Please check your inbox.")
		// 		}).catch(error => {
		// 		this.handleError(error, "Can't restore password. Please try again or contact support.")
		// 	})
		// },

		backToLogin(){
			console.log("backToLogin: this.onBack = ", this.onBack)
			if(this.onBack){
				this.onBack()
			} else {
				this.goOptions(this.backToLoginLink)
			}
		},

		onFormValidated() {
			this.resetPassword()
		},

		clearFormValidationInternal() {
			this.errorMessage = ""
			this.clearFormValidation()
		},


		async resetPassword() {
			this.errorMessage = ''
			try {
				this.progressNonBlocking()
				await this.dataManager.sendPasswordResetEmail(this.form.email)
				this.passwordResetSuccess = true
			} catch (error) {
				this.passwordResetSuccess = false
				let msg = error.message
				console.error(JSON.stringify(error))
				if(error.code === "auth/user-not-found"
					|| error.code === "auth/wrong-password"){
					msg = "We can't find a user with this email. Please check and try again."
				}
				this.errorMessage = msg
			}
			this.hideProgress()
		},
	},


}
</script>

<style lang="scss">
//@import "../../../assets/scss/page";
/*@import "../../assets/css/page.css";*/
@import "login-view";
</style>
